<template>
    <modal name="order-reason-modal" class="order-reason-modal"
           :width="'30%'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="keymodal_title">
            <div class="out_title">{{ title }}</div>
        </div>
        <div class="c_table_wrap modal_table">
            <order-write-component :orderType="orderType" :orderKey="orderKey"></order-write-component>
            <div class="text_center pt20">
                <el-button type="primary" class="out_btn" @click="save">발송</el-button>
                <el-button type="info" class="out_btn" @click="modalClose()">취소</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import util from '@/mixins/util';
import OrderWriteComponent from "../order/OrderWriteComponent";
import EventBus from "@/mixins/event-bus";

export default {
    name: "OrderReasonModal",
    props: {},
    mixins: [],
    components: {OrderWriteComponent},
    computed: {},
    provide() {
        return {
        }
    },
    data() {
        return {
            title : '',
            reason : '',
            orderType : '',
            orderKey : '',
        }
    },
    mounted() {

    },
    methods: {
        handlerBeforeOpen(event) {
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.type)) {
                this.orderType = event.params.type;

                this.checkTitle()
            }
            if(!util.isEmpty(event.params) && !util.isEmpty(event.params.key)){
                this.orderKey = event.params.key;
            }
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
            this.reason = ''

        },
        modalClose() {
            this.$modal.hide('order-reason-modal');
        },
        save(){
            EventBus.$emit('runWrite')
        },
        checkTitle(){
            let type = this.orderType
            switch (type) {
                case 'refundSuccess':
                    this.title = '환불요청 승인'
                    return;
                case 'refundCancel':
                    this.title = '환불요청 거절'
                    return;
                case 'exchangeSuccess':
                    this.title = '교환요청 승인'
                    return;
                case 'exchangeCancel':
                    this.title = '교환요청 거절'
                    return;
                case 'requestSuccess':
                    this.title = '취소 완료'
                    return;
                case 'requestCancel':
                    this.title = '취소요청 철회'
                    return;
                case 'orderRefund':
                    this.title = '환불 안내'
                    return;
                case 'orderChange':
                    this.title = '교환 안내'
                    return;
                case 'beforeCancel':
                    this.title = '주문 취소'
                    return;
            }
        }
    }
}
</script>

<style scoped>

</style>
